module.exports = __webpack_public_path__ + "static/media/upload-svgrepo-com 1.f49180e0.svg";